import React from "react";
import "swiper/css/pagination";
import "./AboutUsFactSection.css";
import "./CompactAboutUsSection.css";

const CompactAboutUsSection = () => {
    return (
        <section className="about-us">
  <div className="about-container">
    {/* Unternehmensbeschreibung */}
    <div className="about-section">
      <h2>Über Uns</h2>
      <p className="about-text">
        Wir sind ein Zusammenschluss aus <strong>7 Freiberuflern</strong>, die ihre Kompetenzen bündeln, 
        um gemeinsam maßgeschneiderte digitale Lösungen anzubieten. Unser Fokus liegt auf 
        zukunftssicheren Technologien, skalierbaren Softwarelösungen und der digitalen Transformation von Unternehmen.
      </p>
    </div>

    {/* Expertise - Bullet Points on the Right */}
    <div className="services-grid">
      <h3>Unsere Kernkompetenzen</h3>
      <ul className="services-list">
        <li>Digitale Transformation & IT-Strategie</li>
        <li>Moderne & skalierbare Softwarearchitektur</li>
        <li>Individuelle Softwarelösungen</li>
        <li>Automatisierte Geschäftsprozesse</li>
      </ul>
    </div>
  </div>
</section>
    );
};  

export default CompactAboutUsSection;